var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "error" } }, [
    _c("section", { staticStyle: { padding: "10px" } }, [
      _c(
        "p",
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("message.pagenotfound")) + "\n      "
          ),
          _c("router-link", { attrs: { to: { name: "Home" } } }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.backtohomepage")) +
                "\n      "
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dcca875e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcca875e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/404.vue
// module id = null
// module chunks = 